import { createContext, useContext, useState, useCallback, useMemo } from "react";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("icdh_lang") || "fr");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("icdh_lang", l);
  }, []);
  const L = useCallback((en, fr) => (lang === "fr" ? fr : en), [lang]);
  const value = useMemo(() => ({ lang, setLang, L }), [lang, setLang, L]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
